import React, { Component } from 'react';
import "./style2.css";

function Box2(props) {
    const {setDonate,donate}=props;
  

    return <>
        <div className="Box">
            <div className='title'  ><img src={require("./title.png")} alt="" /></div>
            <div className='box-content'>
            <p className="txt">
            MNIT Jaipur{" "}
            <span className="txt">
              wants to create a <br></br> wonderful journey. Help us in our{" "}
              <br></br>
              journey to create a fantastic event<br></br> full of
            </span>{" "}
            Technology
          </p>
                <div className="btn2">
                    <button onClick={()=>{setDonate(true)}}>Sponsor</button>
                   
                </div>
            </div>
        </div>
    </>;
}

export default Box2;